import { Link } from "react-router-dom";
import { ArrowRight } from "react-bootstrap-icons";
import SectionHeading from "./SectionHeading";
import { getIcon } from "./icons";
import { ALL_SERVICES } from "./data/landingData";

/** All Services: one card per service, linking to its page. */
const ServicesSection = () => (
  <section className="lp-section lp-section--alt" aria-labelledby="lp-services-title">
    <div className="container">
      <SectionHeading
        id="lp-services-title"
        eyebrow="Everything in one place"
        title="All Services"
        description="Property, interior design, local shops and home services, all on All Home Desire."
      />
      <div className="row g-4">
        {ALL_SERVICES.map(({ title, icon, text, to }) => {
          const Icon = getIcon(icon);
          return (
            <div key={title} className="col-12 col-md-6 col-lg-4">
              <article className="lp-card lp-card--lift h-100 p-4">
                <span className="lp-icon-box mb-3" aria-hidden="true"><Icon /></span>
                <h3 className="lp-card__title">{title}</h3>
                <p className="lp-muted">{text}</p>
                <Link to={to} className="lp-link" aria-label={`Explore ${title}`}>
                  Explore <ArrowRight aria-hidden="true" />
                </Link>
              </article>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default ServicesSection;
